import { TeacherLessonPage } from "@/pages/teacher/TeacherLessonPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/books/lessons/$lessonId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { lessonId } = Route.useParams();
  return <TeacherLessonPage lessonId={lessonId} />;
}
